import React from 'react'
import ReactDOM from 'react-dom'
import { createBrowserHistory } from 'history'
import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux'
import { requestNotificationPermission } from 'firebaseMessaging'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'connected-react-router'
import * as Sentry from '@sentry/react'
import StylesLoader from './stylesLoader'
import reducers from './redux/reducers'
import sagas from './redux/sagas'
import Localization from './localization'
import Router from './router'
import * as serviceWorker from './serviceWorker'
import 'antd/dist/antd.css'

// mocking api
// import 'services/axios/fakeApi'

// middlewared
const history = createBrowserHistory()
const sagaMiddleware = createSagaMiddleware()
const routeMiddleware = routerMiddleware(history)
const middlewares = [sagaMiddleware, routeMiddleware]
// if (process.env.NODE_ENV === 'development') {
// middlewares.push(logger)
// }
// middlewares.push(logger)
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(reducers(history), composeEnhancers(applyMiddleware(...middlewares)))
sagaMiddleware.run(sagas)

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  // Tracing
  tracesSampleRate: process.env.REACT_APP_SENTRY_SAMPLE_RATE, //  Capture 100% of the transactions
  tracePropagationTargets: [/^\/api\//],
})

requestNotificationPermission().then((token) => {
  if (token) console.log('User FCM Token:', token)
})

ReactDOM.render(
  <Provider store={store}>
    <StylesLoader>
      <Localization>
        <Router history={history} />
      </Localization>
    </StylesLoader>
  </Provider>,
  document.getElementById('root'),
)

// PWA: Register service worker for offline functionality
serviceWorker.register({
  onUpdate: (registration) => {
    // Create a better update mechanism to avoid COOP issues
    const updateSW = () => {
      if (registration && registration.waiting) {
        // Use MessageChannel for safer communication
        const messageChannel = new MessageChannel()
        messageChannel.port1.onmessage = (event) => {
          if (event.data.error) {
            console.error('SW update failed:', event.data.error)
          } else {
            window.location.reload()
          }
        }

        registration.waiting.postMessage({ type: 'SKIP_WAITING' }, [messageChannel.port2])
      }
    }

    // Show update available notification
    // eslint-disable-next-line no-alert
    if (window.confirm('New version available! Click OK to update.')) {
      updateSW()
    }
  },
  onSuccess: () => {
    console.log('PWA installed successfully')
  },
})

// src/index.js or App.js
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/custom-messaging-sw.js')
      .then((registration) => {
        console.log('✅ SW registered:', registration.scope)
      })
      .catch((err) => {
        console.error('❌ SW registration failed:', err)
      })
  })
}

export { store, history }
